import { drapcodeIcon } from '../../../../common/custom/icon-library';
import {
  checkDeveloperAPIPermission,
  checkEncryptionPermission,
  checkSystemActivityPermission,
} from '../../../../common/utils/permissions';

export const DEFAULT_MORE_SECTION = 'app-settings';

export const MORE_SECTIONS = [
  {
    id: 'app-settings',
    label: 'App Settings',
    icon: 'webconnect-gear',
    isAllowed: () => true,
  },
  {
    id: 'ai-models',
    label: 'AI Models',
    icon: drapcodeIcon('aiModelConfig'),
    isAllowed: () => true,
  },
  {
    id: 'developer-api',
    label: 'Developer API',
    icon: drapcodeIcon('devKey'),
    isAllowed: checkDeveloperAPIPermission,
  },
  {
    id: 'api-usage',
    label: 'API Usage',
    icon: drapcodeIcon('logs'),
    isAllowed: () => true,
  },
  {
    id: 'environments',
    label: 'Environments',
    icon: drapcodeIcon('environment'),
    isAllowed: () => true,
  },
  {
    id: 'seo',
    label: 'SEO',
    icon: drapcodeIcon('sitemapXml'),
    isAllowed: () => true,
  },
  {
    id: 'encryption',
    label: 'Encryption',
    icon: drapcodeIcon('encryption').trim(),
    isAllowed: checkEncryptionPermission,
  },
  {
    id: 'permissions',
    label: 'Permissions',
    icon: drapcodeIcon('constants'),
    isAllowed: () => true,
  },
  {
    id: 'activity',
    label: 'Activity',
    icon: drapcodeIcon('logs'),
    isAllowed: checkSystemActivityPermission,
  },
];

export function getVisibleMoreSections() {
  return MORE_SECTIONS.filter((section) => section.isAllowed());
}
